<template>
  <BaseModal
    :is-editable="false"
    :is-archivable="false"
    :is-visible="isVisible"
    @hideModal="hideModal()"
    size="lg"
  >
    <template #header>
      {{$t('views.excmtask.show.addMultipleTaskToCaseModal')}}
    </template>
    <template #body>
      <b-row align-h="around">
        <b-col cols="12">
          <b-form-group>
            <label>{{$t('views.excmtask.form.idTaskType')}}:</label>
            <model-select :placeholder="$t('views.excmtask.form.idTaskType')" :options="taskTypes" v-model="taskTypeId"></model-select>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-checkbox class="my-1" v-model="addToPool" :value="1" :unchecked-value="0">
            {{ $t('views.excmtask.form.addToPool') }}
          </b-form-checkbox>
        </b-col>
        </b-row>
        <b-row v-if="addToPool === 0">
          <b-col cols="12">
            <hr class="my-1">
            <b-form-group>
              <label for="dispatchTask">{{$t('modals.excmtask.dispatchUserData')}}</label>
              <model-select id="dispatchTask" v-model="userDataId" :options="userDataOptions"></model-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" v-if="taskType && taskType.taskParams.canBeDailyPlanItem">
            <label
              for="userData"
              class="form-control-label">{{$t('modals.excmtask.date')}}:</label>
            <fg-input>
              <el-date-picker
                :picker-options="{firstDayOfWeek: 1}"
                v-model="dispatchDate"
                type="date">
              </el-date-picker>
            </fg-input>
          </b-col>
          <b-col cols="12" v-if="taskType && taskType.taskParams.canBeDailyPlanItem">
            <label
              for="userData"
              class="form-control-label">{{$t('modals.excmtask.timeStartOnCalendar')}}:</label>
            <VueCtkDateTimePicker no-header
                                  :label="$t('modals.excmtask.timeStartOnCalendar')"
                                  v-model="timeStartOnCalendar"
                                  format="HH:mm"
                                  :right="true"
                                  only-time
                                  formatted="HH:mm"
            >
            </VueCtkDateTimePicker>
          </b-col>
        </b-row>
      <b-row>
        <b-col>
          <button type="button" class="btn btn-danger" @click="hideModal()">{{$t('buttons.cancel')}}</button>
        </b-col>
        <b-col>
          <button
            type="button"
            class="btn btn-success float-right"
            @click="createTasks()"
          >
            {{$t('buttons.accept')}}
          </button>
        </b-col>
      </b-row>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import { ModelSelect } from 'vue-search-select'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'
import { getUserRoles } from '@/utils/checkRoles'
import { ENTRYPOINT } from '@/config/entrypoint'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

export default {
  name: 'CreateMultipleTaskModal',
  components: {
    BaseModal,
    ModelSelect,
    VueCtkDateTimePicker
  },

  props: ['id', 'idCollection'],

  data () {
    return {
      cases: [],
      taskTypes: [],
      taskTypeId: '',
      userDataId: '',
      dispatchDate: '',
      timeStartOnCalendar: '',
      taskType: null,
      addToPool: 0,
      userDataOptions: []
    }
  },
  created () {
    this.getTechnicians()
    this.setCurrentUser()
    this.fetchTaskTypes()
  },
  computed: {
    ...mapGetters({
      isVisible: 'excmcase/createMultipleTaskModal/getIsCreateMultipleTaskModalVisible',
      response: 'excmcase/createMultipleTaskModal/response'
    }),
    path () {
      let url = new URL(ENTRYPOINT)
      return url.pathname
    }
  },
  watch: {
    addToPool (val) {
      if (!val) {
        this.dispatchDate = ''
        this.timeStartOnCalendar = ''
      }
    },
    taskType (val) {
      if (val) {
        if (!val.canUpdate) {
          this.addToPool = 1
          this.userData = null
        } else {
          this.addToPool = 0
          this.setCurrentUser()
        }
      }
    },
    taskTypeId (val) {
      this.getTaskType(val)
      this.getTechnicians(val)
    },
    response () {
      this.$emit('getList')
      this.hideModal()
    },
    isVisible (val) {
      if (val) {
        this.fetchTaskTypes()
      }
    }
  },
  methods: {
    setCurrentUser () {
      this.userDataId = this.path + 'user_datas/' + getUserRoles().id_userdata
    },
    async getTechnicians (idTaskType = undefined) {
      let params = {
        pagination: false,
        idClientType: [...this.$store.getters['configuration/customClientTypeIds'], 4, 5, 14, 15, 16] // 4 - superuser, 5 - serwisant, 14 - controlling, 15 - przedstawiciel handlowy, 16 - projektant zewnętrzny
      }
      if (idTaskType) {
        params.applicableForTaskType = idTaskType
      }
      const response = await new ApiService('user_datas/list', params).getResults()
      this.userDataOptions = response.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.fullName
        }
      })
    },
    createTasks () {
      this.createMultipleTasksForCollection({
        body: {
          'idTaskType': this.taskTypeId,
          'cases': this.idCollection.map(entry => { return getId(entry['@id']) }),
          'userDataId': this.userDataId,
          dispatchDate: this.dispatchDate,
          timeStartOnCalendar: this.timeStartOnCalendar,
          addToPool: this.addToPool
        }
      })
    },
    hideModal () {
      this.resetData()
      this.$emit('reset')
      this.toggleCreateMultipleTaskModal()
    },
    resetData () {
      this.cases = []
      this.taskTypes = []
      this.taskTypeId = ''
      this.userDataId = ''
      this.dispatchDate = ''
      this.timeStartOnCalendar = ''
      this.taskType = null
      this.addToPool = 0
    },
    async fetchTaskTypes () {
      let idCasesType = ''
      if (this.idCollection.length > 0) {
        idCasesType = this.idCollection[0].caseType['@id']
      }
      const response = await new ApiService('e_x_c_m_task_types', { pagination: false, state: 1, idCasesType: idCasesType }).getResults()
      this.taskTypes = response.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title + (entry.idCasesType ? ' (' + entry.idCasesType.title + ')' : '')
        }
      })
    },
    async getTaskType (id) {
      if (id) {
        this.taskType = await new ApiService(id).getResults()
      }
    },
    ...mapMutations({
      toggleCreateMultipleTaskModal: 'excmcase/createMultipleTaskModal/toggleCreateMultipleTaskModal'
    }),
    ...mapActions({
      createMultipleTasksForCollection: 'excmcase/createMultipleTaskModal/createMultipleTasksForCollection'
    })
  }
}
</script>
